import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { SwapBudget } from '@sorare/core/src/atoms/icons/SwapBudget';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, HeadlineXL } from '@sorare/core/src/atoms/typography';

import { CommonPaymentBoxMode } from '../types';

const Wrapper = styled(Vertical)`
  align-items: center;
`;
const Title = styled(BodyM)`
  color: rgba(var(--c-rgb-white), 0.66);
`;
const BigNumber = styled(HeadlineXL)`
  font-size: 56px;
  font-weight: 700;
`;

const UpIcon = () => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.15217 6.54545L0.5 6.54545L0.499999 5.18182L6.5 5.24536e-07L12.5 5.18182L12.5 6.54545L8.84783 6.54545L8.84783 12L4.15217 12L4.15217 6.54545Z"
      fill="#33CE78"
    />
  </svg>
);

const DownIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.34782 5.45455L12 5.45455L12 6.81818L6 12L-1.19213e-06 6.81818L-9.53703e-07 5.45455L3.65217 5.45455L3.65217 6.38566e-07L8.34783 1.68284e-06L8.34782 5.45455Z"
      fill="#F23B27"
    />
  </svg>
);

const title = defineMessages({
  [CommonPaymentBoxMode.ADD]: {
    id: 'commonPaymentBox.content.title.buy',
    defaultMessage: 'You will use',
  },
  [CommonPaymentBoxMode.DROP]: {
    id: 'commonPaymentBox.content.title.sell',
    defaultMessage: 'You will receive',
  },
});

type Props = {
  total: number;
  balance: number;
  mode: CommonPaymentBoxMode;
};

export const Content = ({ total, balance, mode }: Props) => {
  const adding = mode === CommonPaymentBoxMode.ADD;
  const insufficientBalance = adding && balance < total;
  const balanceAfterTransaction = balance + total * (adding ? -1 : 1);
  return (
    <Wrapper>
      <Title bold>
        <FormattedMessage {...title[mode]} />
      </Title>
      <BigNumber
        color={insufficientBalance ? 'var(--c-yellow-600)' : 'var(--c-white)'}
      >
        <Horizontal>
          <SwapBudget size={5} />
          {total}
        </Horizontal>
      </BigNumber>
      <Horizontal>
        <BodyM color="var(--c-nd-600)">
          <FormattedMessage
            id="total"
            defaultMessage="Points balance after transaction:"
          />
        </BodyM>
        <Horizontal>
          <SwapBudget />
          <BodyM
            color={
              insufficientBalance ? 'var(--c-yellow-600)' : 'var(--c-white)'
            }
          >
            {balanceAfterTransaction}
          </BodyM>
          {adding ? <DownIcon /> : <UpIcon />}
        </Horizontal>
      </Horizontal>
    </Wrapper>
  );
};
